import styled from 'styled-components/macro';
import { formInputTextForFilledBack } from '../../../common/colorConstants';

export const Label = styled.label`
  opacity: 0.9;
  color: #7f7f7f;
  font-size: 1.2rem;
  margin-right: 15px;
`;

export const Input = styled.input`
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.3;
  padding: 5px;
  min-width: 200px;
  width: 100%;

  color: ${formInputTextForFilledBack};
  border: 1px solid #4697c3;
  background-color: #f8fafc;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 10px;
  align-items: center;
`;

export const FormRowAlignNone = styled.div`
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;
